import {
	ChangeDetectionStrategy,
	Component,
	input,
	InputSignal,
	OnDestroy,
	signal,
	WritableSignal,
	inject,
} from '@angular/core'
import { TuiDropdown, TuiDropdownManual } from '@taiga-ui/core'
import { TranslatePipe } from '@ngx-translate/core'
import { PositionsInterface } from '@modules/positions-module/interfaces/positions.interface'
import { DropdownVariantEnum } from '@shared/enums/dropdown-variant.enum'
import { CreateOcoOrderComponent } from '@shared/components/trading/positions/stocks/common/create-oco-order/create-oco-order.component'
import { ClosePositionComponent } from '@shared/components/trading/positions/stocks/common/close-position/close-position.component'
import { PositionInfoComponent } from '@shared/components/trading/positions/stocks/common/position-info/position-info.component'
import { SecondaryLiveTickerService } from '@modules/stocks-module/live-ticker/services/secondary-live-ticker.service'
import { ClickOutsideDirective } from '@shared/directives/click-outside.directive'
import { ButtonComponent } from '@shared/components/ui-kit/button/button.component'

@Component({
	selector: 'app-position-stocks-actions',
	templateUrl: './position-stocks-actions.component.html',
	styleUrl: './position-stocks-actions.component.scss',
	changeDetection: ChangeDetectionStrategy.OnPush,
	imports: [
		TranslatePipe,
		TuiDropdown,
		TuiDropdownManual,
		ClosePositionComponent,
		CreateOcoOrderComponent,
		PositionInfoComponent,
		ClickOutsideDirective,
		ButtonComponent,
	],
})
export class PositionStocksActionsComponent implements OnDestroy {
	protected readonly dropdownVariantEnum: typeof DropdownVariantEnum = DropdownVariantEnum

	public position: InputSignal<PositionsInterface | null> = input<PositionsInterface | null>(null)

	private readonly _secondaryLiveTickerService: SecondaryLiveTickerService =
		inject<SecondaryLiveTickerService>(SecondaryLiveTickerService)

	protected openedDropdown: WritableSignal<DropdownVariantEnum | null> = signal(null)
	protected toggleDropdown(dropdown: DropdownVariantEnum | null): void {
		if (this.openedDropdown() === dropdown) {
			this._secondaryLiveTickerService.closeLiveTicker()
			this.openedDropdown.set(null)
		} else {
			this.openedDropdown.set(dropdown)
		}
	}

	protected onClickOutside(): void {
		this._secondaryLiveTickerService.closeLiveTicker()
		this.openedDropdown.set(null)
	}

	ngOnDestroy(): void {
		this._secondaryLiveTickerService.closeLiveTicker()
	}
}
